import { render } from "./DirectoryNav.vue?vue&type=template&id=396e32fa&scoped=true"
import script from "./DirectoryNav.vue?vue&type=script&lang=js"
export * from "./DirectoryNav.vue?vue&type=script&lang=js"

import "./DirectoryNav.vue?vue&type=style&index=0&id=396e32fa&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2319679630/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-396e32fa"]])

export default __exports__